"use client";

import { Button, cn, Icon, PlateContent, Text } from "@cloai/uikit";
import { signOut } from "next-auth/react";
import { useTranslations } from "next-intl";
import { useCallback } from "react";

import { useProfileContext, useUndressContext } from "@/providers";

export const AdminResetUndressButton = ({
  className,
}: {
  className?: string;
}) => {
  const t = useTranslations("Admins");
  const profile = useProfileContext();
  const context = useUndressContext();

  const onLogout = useCallback(() => {
    signOut();
  }, []);

  if (!profile?.isAdmin || !context) {
    return null;
  }

  const { onReset, loading, undressings } = context;

  return (
    <PlateContent color="regular" className={cn("@container", className)}>
      <Text text={t("blockForAdmin")} color="orange" center />

      <div
        className={cn(
          "mx-auto flex w-full max-w-110 flex-col gap-indent",
          "@md:flex-row",
        )}
      >
        <Button
          startContent={<Icon icon="delete" />}
          color="danger"
          wide
          centerText
          onClick={onReset}
          loading={loading}
          disabled={!undressings}
        >
          {t("resetUndress")}
        </Button>

        <Button wide centerText color="danger" onClick={onLogout}>
          {t("logOut")}
        </Button>
      </div>
    </PlateContent>
  );
};
